import AtMainButtonLoading from '../atoms/AtMainButtonLoading';

type Props = {
  mainLabel: string;
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};
/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrButtonAreaNoBackLinkLoading = ({ mainLabel, disabled, isLoading, onClick }: Props) => {
  return (
    <div className='orbuttonareanobacklink'>
      <AtMainButtonLoading
        name='main'
        className='main'
        disabled={disabled}
        isLoading={isLoading}
        onClick={onClick}
      >
        {mainLabel}
      </AtMainButtonLoading>
    </div>
  );
};
/** 初期値の設定 */
OrButtonAreaNoBackLinkLoading.defaultProps = {
  disabled: false,
  isLoading: false,
  onClick: null,
};
/** 初期値の設定 */
export default OrButtonAreaNoBackLinkLoading;
